import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubble3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBubble3"><Path d="M12 21.5C17.2467 21.5 21.5 17.2467 21.5 12C21.5 6.75329 17.2467 2.5 12 2.5C6.75329 2.5 2.5 6.75329 2.5 12C2.5 13.5703 2.88098 15.0516 3.55556 16.3565L2.5 21.5L7.77778 20.5125C9.04968 21.1446 10.4833 21.5 12 21.5Z" stroke="currentColor" strokeLinecap="round"/></CentralIconBase>;
});

export default IconBubble3;
